import { throttle } from 'lodash'

let $html = $('html')
let $window = $(window)
let $document = $(document)

$window.on('scroll resize load', throttle(() => {
    let scroll = $window.scrollTop()
    let position = $window.scrollTop() + $window.height()
    let minPosition = $document.height() - 300
    let pageIsScolledDown = scroll > 0

    $html.toggleClass('-scrolled-down', pageIsScolledDown)
    $html.toggleClass('-should-show-scroll-up', scroll > 200 && position > minPosition)
}, 20))

// Breadcrumbs
$('[id="breadcrumbs"] a').not(':last-child').after(' |')
